import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { U8aFixed } from '@polkadot/types-codec';
import { BN, bnToU8a, isNumber, stringToU8a, u8aToHex, u8aToString } from '@polkadot/util';
export var CID_AURA = stringToU8a('aura');
export var CID_BABE = stringToU8a('BABE');
export var CID_GRPA = stringToU8a('FRNK');
export var CID_POW = stringToU8a('pow_');

function getAuraAuthor(registry, bytes, sessionValidators) {
  return sessionValidators[registry.createTypeUnsafe('RawAuraPreDigest', [bytes.toU8a(true)]).slotNumber.mod(new BN(sessionValidators.length)).toNumber()];
}

function getBabeAuthor(registry, bytes, sessionValidators) {
  var digest = registry.createTypeUnsafe('RawBabePreDigestCompat', [bytes.toU8a(true)]);
  return sessionValidators[digest.value.toNumber()];
}

function getBytesAsAuthor(registry, bytes) {
  return registry.createTypeUnsafe('AccountId', [bytes]);
}
/**
 * @name GenericConsensusEngineId
 * @description
 * A 4-byte identifier identifying the engine
 */


export var GenericConsensusEngineId = /*#__PURE__*/function (_U8aFixed) {
  _inherits(GenericConsensusEngineId, _U8aFixed);

  var _super = _createSuper(GenericConsensusEngineId);

  function GenericConsensusEngineId(registry, value) {
    _classCallCheck(this, GenericConsensusEngineId);

    return _super.call(this, registry, isNumber(value) ? bnToU8a(value, {
      isLe: false
    }) : value, 32);
  }
  /**
   * @description `true` if the engine matches aura
   */


  _createClass(GenericConsensusEngineId, [{
    key: "isAura",
    get: function get() {
      return this.eq(CID_AURA);
    }
    /**
     * @description `true` is the engine matches babe
     */

  }, {
    key: "isBabe",
    get: function get() {
      return this.eq(CID_BABE);
    }
    /**
     * @description `true` is the engine matches grandpa
     */

  }, {
    key: "isGrandpa",
    get: function get() {
      return this.eq(CID_GRPA);
    }
    /**
     * @description `true` is the engine matches pow
     */

  }, {
    key: "isPow",
    get: function get() {
      return this.eq(CID_POW);
    }
    /**
     * @description From the input bytes, decode into an author
     */

  }, {
    key: "extractAuthor",
    value: function extractAuthor(bytes, sessionValidators) {
      if (sessionValidators !== null && sessionValidators !== void 0 && sessionValidators.length) {
        if (this.isAura) {
          return getAuraAuthor(this.registry, bytes, sessionValidators);
        } else if (this.isBabe) {
          return getBabeAuthor(this.registry, bytes, sessionValidators);
        }
      } // For pow & Moonbeam, the bytes are the actual author


      if (this.isPow || bytes.length === 20) {
        return getBytesAsAuthor(this.registry, bytes);
      }

      return undefined;
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman() {
      return this.toString();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'ConsensusEngineId';
    }
    /**
     * @description Override the default toString to return a 4-byte string
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.isAscii ? u8aToString(this) : u8aToHex(this);
    }
  }]);

  return GenericConsensusEngineId;
}(U8aFixed);